import React, { useEffect, useState } from "react";
import SubmissionImage from "./Assets/newSubmission.svg";
import { useSelector, useDispatch } from "react-redux";
import { OpenLoginSignUp } from "../../../../Actions/ToggleSignupA";
import { FaCheckCircle } from "react-icons/fa"; // Import check icon
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { StepConnector, styled, Typography  } from "@mui/material";
import { FaCheck } from "react-icons/fa"; // Import tick icon
import { GetVLIAgentsA, UpdateVLIAgentsReferrals } from "../../../../Actions/StudentA";
import LoadingSpinner from "../../../../Components/LoadingSpinner/LoadingSpinner";

// Custom Connector
const CustomConnector = styled(StepConnector)(({ theme }) => ({
    "&.MuiStepConnector-root": {
      top: 10, // Adjust vertical alignment
    },
    "& .MuiStepConnector-line": {
      borderColor: "#BEBFED", // Line color
      borderTopWidth: 10, // Line thickness (10px)
      borderRadius: 5, // Smooth edges
    },
  }));
  
  // Custom Step Icon Styling
const CustomStepIcon = styled("div")(({ completed }) => ({
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: completed ? "#A1A3EF" : "#BEBFED", // Completed steps use #A1A3EF
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.2rem",
    color: "#fff",
    fontWeight: "bold",
  }));

const stepStatuses = ["(Completed)", "(In Progress)", "(Pending)", "(Pending)"];

const CustomStepLabel = ({ label, status }) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <Typography
      sx={{
        fontWeight: "bold", // Always bold
        fontSize: { xs: "14px", lg: "17px" },
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: { xs: "12px", lg: "14px" },
      }}
    >
      {status}
    </Typography>
  </Box>
);
  
const steps = ["Submission", "Registration Approval", "Payment Received", "Registration Confirmation"];

const CustomStepIconComponent = (props) => {
  const { active, completed, icon } = props;
  return (
    <CustomStepIcon completed={completed}>
      {completed ? <FaCheck size={20} /> : icon} {/* Show tick for completed steps */}
    </CustomStepIcon>
  );
};

const InstituteSubmissionScreen = ({setOpenSignupScreen, InstituteData}) => {
    const dispatch = useDispatch();
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const { VLIAgentsData } = useSelector((Store) => Store.StudentReducer);
    console.log("VLIAgentsData is:",VLIAgentsData)

    const [selectedReferral, setSelectedReferral] = useState("");
    const [selectedAgent, setSelectedAgent] = useState("");
    const [selectedAgentId, setSelectedAgentId] = useState(null);  // Store the selected agent ID
  
    const referralOptions = [
      "Through social media",
      "Through a friend or family member",
      "Online search (Google, Bing, Yahoo)",
      "Associate Member",
    ];
  
    const referralAgents = ["Agent A", "Agent B", "Agent C", "Agent D"]; // Replace with actual agent names
  
    const handleReferralChange = (e) => {
      setSelectedReferral(e.target.value);
      setSelectedAgent(""); // Reset agent selection if the user changes referral
    };

    useEffect(() => {
      dispatch(GetVLIAgentsA())
  }, []); // Empty array means this runs once on component mount

  // Handle the change event for selecting an agent
    const handleAgentChange = (e) => {
      const selectedId = e.target.value;

      // Find the selected agent object using its unique ID
      const selectedAgentData = VLIAgentsData.find(agent => agent.AssociatePartnerId === selectedId);

      if (selectedAgentData) {
          setSelectedAgent(selectedAgentData.AssociatePartnerName);  // Set the agent name
          setSelectedAgentId(selectedId);  // Set the agent ID
          dispatch(UpdateVLIAgentsReferrals(selectedAgentData.AssociatePartnerName,selectedId))
      }
  };

  return (
  <div className="w-[100%] h-[600px] 2xl:h-[700px] flex flex-col">
    <div className="w-full flex p-[20px]">
            <div className="w-full lg:w-[60%] flex flex-col lg:p-[30px]">
                <p className="text-[50px] lg:text-[60px] font-bold ">Submission Successful</p>
                <p className="text-[20px]  mt-[30px]">Thank you for choosing Vehicle Learning Innovation.</p>
                <p className="text-[20px]  mt-[30px]  lg:w-[650px]">Your application has been successfully submitted! Our team is reviewing your details, and we’ll get back to you as soon as possible with the next step.</p>

                <Box sx={{ width: "100%", mt: 5, ml:{ xs: "-25px", lg: "-40px" }, display: "flex", justifyContent: "start" }}> {/* Center the stepper */}
                  <Stepper activeStep={1} alternativeLabel connector={<CustomConnector />}>
                    {steps.map((label, index) => (
                      <Step key={label} completed={index === 0}> {/* Mark first step as completed */}
                        <StepLabel StepIconComponent={CustomStepIconComponent}>
                        <CustomStepLabel label={label} isBold={true} status={stepStatuses[index]} />
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>

                <p className="text-[20px]  mt-[30px] font-bold">What's Next?</p>
                <p className="text-[20px]">The VLI support team will contact you soon.</p>
                <p className="text-[20px] lg:w-[80%] mt-[5px]">Once your application is reviewed, you will receive an email with next step.</p>

                {/* Referral Select */}
                {/* <select
                    id="referralSource"
                    name="referralSource"
                    className={`w-full lg:w-[50%] mt-[30px] rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] text-[#000000]`}
                    value={selectedReferral}
                    onChange={handleReferralChange}
                  >
                    <option value="">How did you hear about us?</option>
                    {referralOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                </select>

                {selectedReferral === "Associate Member" && (
                  <select
                    id="referralAgent"
                    name="referralAgent"
                    className={`w-full lg:w-[50%] mt-[20px] rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] text-[#000000]`}
                    value={selectedAgentId}
                    onChange={handleAgentChange}
                  >
                    <option value="">Select Associate Member</option>
                      {VLIAgentsData.map((agent) => (
                          <option key={agent.AssociatePartnerId} value={agent.AssociatePartnerId}>
                              {agent.AssociatePartnerName} ({agent.AssociatePartnerId})
                          </option>
                      ))}
                  </select>
                )} */}
            </div>

            <div className="hidden lg:flex w-[40%]">
                <img src={SubmissionImage} alt="SubmissionImage" className="w-[100%] ml-[-40px] mt-[-40px] h-[]" />
            </div>
    </div>

    <div className="w-full flex justify-center lg:justify-center gap-[20px] mt-[40px] lg:mt-[0px] pb-[50px] lg:pb-[50px]">
        {/* <button
            className={`w-[150px] lg:w-[250px] 2xl:w-[350px] cursor-pointer rounded-[8px]  py-2
                    text-[16px] text-[#625BA8]  xl:py-2 
                        xl:text-[18px]     2xl:text-base`}
        style={{
            border:"3px solid #625BA8"
        }}
        onClick={() => {
            const isLocalhost = window.location.hostname === "localhost";
            window.location.href = isLocalhost
            ? "http://localhost:3000"
            : "https://vehiclelearning.com/"; // Replace with your live site URL
        }}
        >
            Continue to Dashboard
        </button> */}
        <button
            className={`w-[150px] lg:w-[200px] cursor-pointer rounded-[8px] border-none bg-[#625BA8]  py-2
                    text-[16px] text-white  xl:py-3 
                        xl:text-[18px]     2xl:text-base`}
            // onClick={() => {
            //       const isLocalhost = window.location.hostname === "localhost";
            //       window.location.href = isLocalhost
            //       ? "http://localhost:3000"
            //       : "https://vehiclelearning.com/"; // Replace with your live site URL
            // }}
            onClick={() => {
              const currentOrigin = window.location.origin;
              window.location.href = currentOrigin;
            }}

            // onClick={() => dispatch(OpenLoginSignUp("Sign In", true, "Partner"))}
        >
            Back To Home
        </button>
    </div>

  </div>
  );
}

export default InstituteSubmissionScreen;
